import { config } from "../../config/config";
import { Observable } from "rxjs";
import { utilService } from "../utils";
import "react-notifications/lib/notifications.css";

/**
 * Api services for absences component
 */
export const absencesService = {
  getCarerStudents,
  getAbsences,
  fetchAbsencePercentage,
  fetchStudentInfo,
  sendAbsentEmail,
  saveAbsenceReason,
};

function getCarerStudents(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.carerstudents, {
      method: "GET",
      headers: {
        Authorization: data,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}
function getAbsences(data) {
  let params = "";
  if (data.params) {
    params = data.params;
  }
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.absences + data.id + params, {
      method: "GET",
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}
function fetchAbsencePercentage(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.absence_percentage + data.id, {
      method: "GET",
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}
function fetchStudentInfo(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.student_info + data.params, {
      method: "GET",
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}
function sendAbsentEmail(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.send_absent_email, {
      method: "POST",
      headers: {
        Authorization: data.token,
      },
      body: JSON.stringify(data.data),
    })
      .then(utilService.handleResponse)
      .then((result) => {
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}
function saveAbsenceReason(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.absences, {
      method: "POST",
      headers: {
        Authorization: data.token,
      },
      body: JSON.stringify(data.data),
    })
      .then(utilService.handleResponse)
      .then((result) => {
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}
